import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { IDropdownOptions, SharedDataService } from '../../@core/service/shared-data.service';
import { IssuerData, CountryCodes } from '../../@models/erp/compilationData';
import { ApiService } from '../../@core/service/api.service';
import { ReportsComponent } from '../erp/reports/reports.component';
import { AuthGuardService } from '../../@core/service/auth-guard.service';
import { ReportsPrinterComponent } from '../erp/reports/reports-printer/reports-printer.component';
import { EBusinessType, EContactType } from '../../@models';
import { ActivatedRoute } from '@angular/router';
import { mongoId } from '../../@core/common/global';
import { EventService } from '../../@core/service/eventService';

@Component({
  selector: 'app-openorders',
  templateUrl: './openorders.component.html',
  styleUrls: ['./openorders.component.scss']
})
export class OpenordersComponent implements OnInit, AfterViewInit {

  @ViewChild('reportsPrinter') reportsPrinter: ReportsPrinterComponent;
  @ViewChild('xlsPrinter') xlsPrinter: ReportsPrinterComponent;

  search: any;
  xlsSearch: any;

  customerReferenceOptions = null;
  finishedProductOptions = null;

  finishedProductBusinessId = null;
  finishedProductOptionsMulti = [];

  issuerOptions = IssuerData.getOptions();
  countryOptions = CountryCodes.getOptions();

  employeeOptions: IDropdownOptions[] = [];

  loading = true;
  xlsLoading = true;

  subscriptions = [];

  filter = {
    issuer: null,
    country: null,
    customers: [],
    customerDocumentNumbers: [],
    finishedProducts: [],
    businessUnits: [],
    relatedSPOs: 2,
    showMarkup: 1,
    sampleRequest: 1,
    manager: null,
    variant: null,
    projectNumber: '',
    projectOverview: true,
  }

  constructor(
    protected data: SharedDataService,
    protected api: ApiService,
    private auth: AuthGuardService,
    private cdRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private event: EventService,
  ) { }

  ngOnInit() {

    this.data.loadUsers();
    this.data.loadBusinesses();
    this.data.loadProducts();
    this.data.loadContacts().then((contacts) => {
      this.employeeOptions = contacts.filter(f => f.business?.type === EBusinessType.NRK && f.type === EContactType.Employee).map(m => ({id: m._id, name: m.displayTitle}))
    })
    this.data.loadBusinessUnits().then(() => this.reload());
  }

  ngAfterViewInit(): void {
    this.loadMessage();
    this.subscriptions.push(this.event.showMessage.subscribe(msg => {
      this.loadMessage(msg);
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }


  async customersChanged(customerIds: string[]) {
    if (customerIds && customerIds.length) {
      this.api.getCustomerDocRefs(customerIds).then(customerRefs =>
        this.customerReferenceOptions = customerRefs.map(m => ({
          id: m.customerDocumentNumber,
          name: `${m.customerDocumentNumber} | ${m.nameOverride || m.code} | ${m.issueDate.split('T')[0]}`,
        })).filter(f => f.id)
      );

      const finishedProducts = await this.api.getCustomerFinishedProducts(customerIds);
      this.finishedProductOptions = finishedProducts.map(m => ({
        id: m._id,
        name: `${m.calcCode} | ${m.calcName} || ${m.externalCode} | ${m.externalName}`,
      }));
    }
  }

  reload(variant = this.filter.variant) {
    const search = { noninvoiced: JSON.parse(JSON.stringify(ReportsComponent.defaultReport.noninvoiced)) }
    search.noninvoiced.orientation= 'portrait';
    // dateType = DateSelectionData.currentYear.id,
    search.noninvoiced.manager = this.filter.manager; // this.auth.user && this.auth.user.erpRoles && this.auth.user.erpRoles.dashboardType === 1 ? this.auth.user.contact : null;
    search.noninvoiced.issuer = this.filter.issuer;
    search.noninvoiced.country = this.filter.country;
    search.noninvoiced.customers = this.filter.customers;
    search.noninvoiced.customerDocumentNumbers = this.filter.customerDocumentNumbers;
    search.noninvoiced.businessUnits = this.filter.businessUnits;
    search.noninvoiced.finishedProducts = this.filter.finishedProducts;
    search.noninvoiced.filterInternal = true;
    search.noninvoiced.sampleRequest = this.filter.sampleRequest;
    search.noninvoiced.limit = 50;
    search.noninvoiced.sortType = 1;
    search.noninvoiced.dateFrom = new Date('2016-01-01');
    search.noninvoiced.dateTo = null;
    // search.noninvoiced.filterCompletedProjects = false;
    // search.noninvoiced.showInvoicedOCs = this.filter.projectOverview;
    search.noninvoiced.projectOverview = false;
    search.noninvoiced.projectNumber = this.filter.projectNumber;
    this.search = search;

    this.xlsSearch = structuredClone(search);
    this.xlsSearch.noninvoiced.extended = 5;
    this.xlsSearch.noninvoiced.sortType = 3

    // if (variant === 401 || variant === 402) {
    //   search.noninvoiced = {
    //     ...search.noninvoiced,
    //     dateFrom: -1,
    //     dateTo: -1,
    //     sortByManager: variant === 401,
    //     sampleRequest: 3, // no SR
    //     projectOverview: true,
    //     filterCompletedProjects: true,
    //     showInvoicedOCs: true,
    //     businessUnits: this.filter.businessUnits?.length ? this.filter.businessUnits : [
    //       mongoId(this.data.businessUnits.find(f => f.code === 'AM')),
    //       mongoId(this.data.businessUnits.find(f => f.code === 'FX')),
    //       mongoId(this.data.businessUnits.find(f => f.code === 'MM')),
    //       mongoId(this.data.businessUnits.find(f => f.code === 'BA')),
    //       mongoId(this.data.businessUnits.find(f => f.code === 'VI')),
    //     ]
    //   }
    // }

    console.log('search', this.search, search, this.search.noninvoiced.customers);
    this.cdRef.detectChanges();
    this.reportsPrinter.abortReload();
    this.reportsPrinter.reloadData(true);

    this.xlsPrinter.abortReload();
    this.xlsPrinter.reloadData(true);

  }

  reportLoaded() {
    this.loading = false;
    // const code = this.route.snapshot.queryParams.code;
    // if (code) this.reportsPrinter.scrollToDoc(code);
    this.loadMessage();
  }

  xlsLoaded() {
    this.xlsLoading = false;
  }

  async loadMessage(msg = null) {
    const messageId = this.route.snapshot.queryParams.message;
    if (messageId || msg) {
      await this.data.loadWarehousing();
      const message = msg ? msg : this.data.warehousingMessages.find(f => mongoId(f) === messageId);
      // const code = this.route.snapshot.queryParams.code;
      console.log('report loaded', message.code, message);
      if (this.reportsPrinter) {
        this.reportsPrinter.scrollToDoc(message.code);
        this.reportsPrinter.openMessage(message);
      }
    }
  }

  deliveryStatusXls() {
    this.xlsPrinter.onDownloadExcel();
  }


}
